import ITranslationImages from "./ITransalationImages"
import BanksLogos from "../../images/paymentTypeLogo/banks-en.png"

export const enImages: ITranslationImages = {
    images: {
        bankLogos: BanksLogos,
    },
}
